<template>
    <div class="side-right to-hide-right_side-right" :class="show?'to-open-left_side-right':'to-hide-right_side-right'">
        <div claass="wrap-side-right scrollable">
            <div class="study">
                <span>StudyDate</span>
                <div class="date">
                    22-May-14
                </div>
            </div>
            <div class="measurements d-flex justify-content-between">
                <h4>Measurements</h4>
                <span>0</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['show']
    }
</script>